import { render } from "./pricing.vue?vue&type=template&id=dee2e540&scoped=true"
import script from "./pricing.vue?vue&type=script&lang=js"
export * from "./pricing.vue?vue&type=script&lang=js"

import "./pricing.vue?vue&type=style&index=0&id=dee2e540&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dev2\\Documents\\dev\\sitio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee2e540"]])

export default __exports__